export default "__VITE_ASSET__Ba9N0mmE__"